import { PieCustomLayerProps, ResponsivePie } from "@nivo/pie";

import { ClientsPageAnalytics, PieData, TranslatedContent } from "../../types";
import { ChartCenteredMetric } from "./ChartCenteredMetric";
import { ChartLegend } from "./ChartLegendV2";
import { ChartTooltipV2 } from "./ChartTooltipV2";

export const ChartPie = ({
  data,
  translations,
  analytics,
}: {
  data: PieData[];
  translations: TranslatedContent;
  analytics?: ClientsPageAnalytics;
}) => {
  const ChartCenteredMetricWrap = (props: PieCustomLayerProps<PieData>) => {
    const total = props.dataWithArc.reduce(
      (sum, datum) => sum + datum.value,
      0,
    );
    const label = translations.accountReportTab.graphs.totalAccounts;
    return <ChartCenteredMetric {...props} total={total} label={label} />;
  };

  return (
    <div
      id="chart-pie"
      className="flex w-full flex-col justify-center gap-4 lg:flex-row lg:gap-20"
    >
      <div className="h-60 w-full lg:w-60">
        <ResponsivePie
          margin={{ top: 2, right: 2, bottom: 2, left: 2 }}
          data={data}
          innerRadius={0.7}
          padAngle={2}
          cornerRadius={4}
          enableArcLinkLabels={false}
          enableArcLabels={false}
          colors={{ datum: "data.color" }}
          layers={[
            "arcs",
            "arcLabels",
            "arcLinkLabels",
            "legends",
            ChartCenteredMetricWrap,
          ]}
          tooltip={(props) => (
            <ChartTooltipV2
              data={props.datum.data}
              translations={translations}
              analytics={analytics}
            />
          )}
        />
      </div>
      <ChartLegend data={data} translations={translations} />
    </div>
  );
};
